export default __webpack_public_path__ + "static/assets/2c81458d2d6c90f4b3c418a938167567.png";